import store from '../store/index'
import ApiService from './api.service'

// const parseJwt = (token) => {
//   const base64Url = token.split('.')[1];
//   const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
//   const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
//     return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
//   }).join(''));

//   return JSON.parse(jsonPayload);
// };

class AuthService {
  login(user) {
    store().state.globalstore.loading = true
    return ApiService
      .postRequest('authentication_token', {
        email: user.email,
        password: user.password
      })
      .then(response => {
        let token = response && response.data && response.data.token
        if(!token) {
          throw "Got wrong response from 'authentication_token' route"
        }

        document.cookie = "auth-token=" + token + "; HttpOnly; Secure; samesite=strict"

        localStorage.setItem('token', JSON.stringify(token));
        return this.refreshUserData()
      })
      .finally(() => store().state.globalstore.loading = false)
  }

  logout() {
    localStorage.clear();
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('roles');
  }

  checkRole(role){
    const roles =  JSON.parse(localStorage.getItem('roles'));
    return (roles.includes(role))
  }

  refreshUserData() {
    return ApiService.getRequest('/users/me').then( response => {
        if(!response || !response.data || typeof response.data !== 'object') {
          throw 'Could not correctly parse response from route /users/me'
        }

        let user = response.data
        localStorage.setItem('roles', JSON.stringify(user.roles));

        delete user.roles
        localStorage.setItem('user', JSON.stringify(user));
        return user
      })
  }

  switchAntenne(antenne) {
    // antenne can be an IRI ("/api/antennes/{id}") or a numeric id
    return ApiService.postRequest('/users/me/switch_antenne', { antenne })
  }

  resetPassword(user) {
    return ApiService.postRequest('forgot_password/', {
      email: user.email,
    }).then( response => {
      // console.log(response)
    })
  }

  /**
   * Connexion SSO Google : échange le code d'autorisation contre un JWT.
   * Appelé après le callback Google sur la page /login/google-callback.
   * Envoie redirect_uri (origine courante + /login/google-callback) pour correspondre à l'URI utilisée à l'auth.
   * @param {string} code - Code retourné par Google
   */
  loginWithGoogleCode(code) {
    const redirectUri = typeof window !== 'undefined'
      ? `${window.location.origin}/login/google-callback`
      : null
    const body = redirectUri ? { code, redirect_uri: redirectUri } : { code }
    store().state.globalstore.loading = true
    return ApiService
      .postRequest('auth/google/sso/exchange', body, true)
      .then((response) => {
        const token = response?.data?.token
        if (!token) {
          throw new Error("Réponse invalide de l'API")
        }
        localStorage.setItem('token', JSON.stringify(token))
        document.cookie = "auth-token=" + token + "; HttpOnly; Secure; samesite=strict"
        return this.refreshUserData()
      })
      .finally(() => store().state.globalstore.loading = false)
  }

  /**
   * Récupère l'URL de redirection Google pour initier le SSO.
   * Envoie l'origine courante (ex. https://synapps-solution.fr) pour que la redirection après Google se fasse vers ce domaine.
   */
  getGoogleSsoUrl() {
    const origin = typeof window !== 'undefined' ? window.location.origin : ''
    const params = origin ? { origin } : {}
    return ApiService.getRequest('auth/google/sso/url', params, true).then(
      (response) => {
        const data = response?.data
        if (data?.redirect_uri_used && process.env.DEV) {
          console.log(
            '[SSO Google] URI de redirection utilisée:',
            data.redirect_uri_used,
            '— À ajouter dans Google Cloud Console en cas d\'erreur redirect_uri_mismatch'
          )
        }
        return data?.redirect_url
      }
    )
  }
}

export default new AuthService();
